import styled from 'styled-components';
import { ColorAddiCompFiveLighten4, ColorAddiCompFourLighten4, ColorAddiCompTwoLighten4, ColorAddiFeedbackError, ColorAddiFeedbackWarning, ColorAddiGrayDarken3, ColorAddiPrimaryActive, } from '@addi/foundation/dist/mobile/colors';
import { PopupType } from './popup-message.types';
import { Paragraph } from '../typographies';
export const BigPopupContainer = styled.div `
  bottom: 4px;
  max-width: 400px;
  width: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  ${({ type }) => {
    switch (type) {
        case PopupType.ERROR:
            return `border-color: ${ColorAddiFeedbackError};
                    background-color: ${ColorAddiCompFourLighten4};`;
        case PopupType.WARNING:
            return `border-color: ${ColorAddiFeedbackWarning};
                    background-color: ${ColorAddiCompTwoLighten4};`;
        default:
            return `border-color: ${ColorAddiPrimaryActive};
                    background-color: ${ColorAddiCompFiveLighten4};`;
    }
}}
`;
export const BigPopupInnerContainer = styled.div `
  display: flex;
  flex-direction: row;
  padding: 9px 19px;
  justify-content: flex-start;
  align-items: center;
`;
export const IconContainer = styled.div `
  position: relative;
  width: 13%;
`;
export const Icon = styled.img `
  width: 20px;
  height: 18px;
  position: relative;
`;
export const Text = styled(Paragraph) `
  font-weight: 400;
  font-size: 18px;
  line-height: 26.64px;
  color: ${ColorAddiGrayDarken3};
  margin: 0;
`;
//# sourceMappingURL=popup-message.styled.js.map